/**
 * Custom hooks for exercises and workouts (Epic 3)
 */
import useSWR from "swr";
import { fetcher, api } from "../lib/api";

// ============================================
// MUSCLE GROUPS
// ============================================

export function useMuscleGroups() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/admin/exercises/muscle-groups",
    fetcher
  );
  
  return {
    muscleGroups: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

// ============================================
// EXERCISES
// ============================================

export function useExercises() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/admin/exercises",
    fetcher
  );
  
  return {
    exercises: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useExercise(exerciseId) {
  const { data, error, isLoading, mutate } = useSWR(
    exerciseId ? `/api/admin/exercises/${exerciseId}` : null,
    fetcher
  );
  
  return {
    exercise: data,
    isLoading,
    isError: error,
    mutate,
  };
}

export async function createExercise(data) {
  return api.post("/api/admin/exercises", data);
}

export async function updateExercise(exerciseId, data) {
  return fetcher(`/api/admin/exercises/${exerciseId}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export async function deleteExercise(exerciseId) {
  return api.delete(`/api/admin/exercises/${exerciseId}`);
}

export async function seedMuscleGroups() {
  return api.post("/api/admin/exercises/muscle-groups/seed", {});
}

// ============================================
// WORKOUT TEMPLATES
// ============================================

export function useWorkoutTemplates() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/admin/templates",
    fetcher
  );
  
  return {
    templates: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useWorkoutTemplate(templateId) {
  const { data, error, isLoading, mutate } = useSWR(
    templateId ? `/api/admin/templates/${templateId}` : null,
    fetcher
  );
  
  return {
    template: data,
    isLoading,
    isError: error,
    mutate,
  };
}

export async function createWorkoutTemplate(data) {
  return api.post("/api/admin/templates", data);
}

export async function updateWorkoutTemplate(templateId, data) {
  return fetcher(`/api/admin/templates/${templateId}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export async function deleteWorkoutTemplate(templateId) {
  return api.delete(`/api/admin/templates/${templateId}`);
}

// ============================================
// CLOUDINARY UPLOAD
// ============================================

export async function uploadMedia(file) {
  const formData = new FormData();
  formData.append("file", file);
  
  const token = localStorage.getItem("access_token");
  const API_URL = process.env.REACT_APP_BACKEND_URL;
  
  const response = await fetch(`${API_URL}/api/admin/exercises/upload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || "Erreur d'upload");
  }
  
  return response.json();
}
